import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  position: relative;
  width: 100%;
  background: #000000;
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  min-height: clamp(110px, 14vw, 160px);
  margin: 0 clamp(18px, 2.8vw, 28px);
  padding: clamp(32px, 4vw, 44px) clamp(12px, 3vw, 24px) clamp(24px, 3vw, 32px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
`;

const TitleRow = styled.div`
  position: relative;
  z-index: 1;
  width: min(100%, 980px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(10px, 1.8vw, 20px);

  @media screen and (max-width: 640px) {
    justify-content: flex-start;
  }
`;

const Title = styled.h2`
  margin: 0;
  white-space: nowrap;
  color: #ffffff;
  text-transform: uppercase;
  font-family: 'Futura Condensed Extra Bold', Futura, Arial, sans-serif;
  font-size: clamp(40px, 6.25vw, 120px);
  line-height: 0.9;
`;

export const TimelineGtiTitle = (): React.ReactElement => {
  return (
    <Section aria-labelledby="timeline-gti-title">
      <Content>
        <TitleRow>
          <Title id="timeline-gti-title">50 AÑOS DE GTI</Title>
        </TitleRow>
      </Content>
    </Section>
  );
};
